/*Import Estilo*/
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';
import Modal from 'react-modal';


/*Import Bibliotecas*/
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

/*Import Componentes*/
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';
import ComprovantePedido from '../../../../components/ComprovanteEstilizado';

/*Import Requisição API*/
import api from '../../../../api';
import { formatadorCNPJ, formatadorCPF, formatadorNumeroCelular } from '../../../../utils/Validadores';
import { formatarPrecoUnitario } from '../../../../utils/precoUnitario';
import { useAuth } from '../../../../context/AuthContext';
import { useToast } from '../../../../context/ToastContext';
import MapComponent from '../../../../components/MapComponet';
import CurrencyInput from 'react-currency-input-field';

export default function VisualizarPedido() {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    // Tenta pegar ID do state primeiro (navegação interna), senão pega do query parameter (QR code)
    const id_pedido = location.state?.id || searchParams.get('id');
    const navigate = useNavigate();
    const { nivelAcesso } = useAuth();
    const { showToast } = useToast();
    Modal.setAppElement('#root');

    const [clientes, setClientes] = useState([]);
    const [usuario_id, setIdUsuario] = useState();
    const [pesquisa, setPesquisa] = useState('');
    const [pesquisaProduto, setPesquisaProduto] = useState('');
    const [pesquisaProdutosCarrinho, setPesquisaProdutosCarrinho] = useState("");
    const [mostrarLista, setMostrarLista] = useState(true);

    const [statusPagamento, setStatusPagamento] = useState(true);

    // dados do cliente
    const [idCliente, setIdCliente] = useState(null);
    const [nome, setNome] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [email, setEmail] = useState("");
    const [celular, setCelular] = useState("");
    const [ie, setIe] = useState("");
    const [dataNascimento, setDataNascimento] = useState("");
    const [sexo, setSexo] = useState("");
    const [nivel, setNivel] = useState("");

    const [cep, setCep] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [complemento, setComplemento] = useState("");
    const [bairro, setBairro] = useState("");
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");

    const [pedido, setPedido] = useState("");
    const [lucroTotal, setLucroTotal] = useState(0);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    // carrinho e produtos
    const [produtos, setProdutos] = useState([]); // se precisar mostrar lista de produtos
    const [item, setItem] = useState([]); // se precisar mostrar lista de produtos
    const [carrinho, setCarrinho] = useState([]);

    // pagamento e totais

    const [destination, setDestination] = useState(null);

    const [modalAberto, setModalAberto] = useState(false);
    const [idProdutoParaExcluir, setIdProdutoParaExcluir] = useState(null);
    const [dialogMensagem, setDialogMensagem] = useState('');
    const [mostrarDialogMensagem, setMostrarDialogMensagem] = useState(false);
    const caixaDeDialogo = useRef(null);
    const dialogMensagemRef = useRef(null);
    const dialogSepararRef = useRef(null);
    const [statusPendente, setStatusPendente] = useState(null);

    const [dataPagamento, setDataPagamento] = useState('');
    const [vencimento, setVencimento] = useState('');

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById('CaixaDeDialogo');
        dialogMensagemRef.current = document.getElementById('DialogMensagem');
    }, []);

    const mostrarMensagem = (mensagem) => {
        setDialogMensagem(mensagem);
        setMostrarDialogMensagem(true);
        if (dialogMensagemRef.current) {
            dialogMensagemRef.current.showModal();
        }
    };

    const fecharDialogMensagem = () => {
        setMostrarDialogMensagem(false);
        if (dialogMensagemRef.current) {
            dialogMensagemRef.current.close();
        }
    };

    const confirmarMudancaStatus = () => {
        dialogSepararRef.current?.close();
        if (!statusPendente) return;
        const novoStatus = statusPendente;
        setStatusPendente(null);
        api.put(`/usuario/${usuario_id}/pedidos/${pedido.id}/atualizar-status`, {
            itemChecks,
            statusAtual: novoStatus
        })
            .then(() => setPedido(prev => ({ ...prev, status: novoStatus })))
            .catch(() => showToast('Erro ao atualizar status', 'error'));
    };

    const fecharModal = () => {
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.close();
        }
    };

    const abrirModalExcluir = (id_produto) => {
        setIdProdutoParaExcluir(id_produto);
        console.log('Passei aqui!');
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    function parseCurrency(value) {
        if (!value) return 0;
        return parseFloat(
            value.replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '')
        );
    }

    const confirmarExcluirProduto = async () => {
        try {
            console.log('Excluindo produto com ID:', idProdutoParaExcluir);
            await api.delete(`/produto/${idProdutoParaExcluir}`, {
                data: { usuario_id },
            });
            setProdutos(produtos.filter(produto => produto.id_produto !== idProdutoParaExcluir));
            fecharModal();
            navigate('/menu/produtos_e_estoque');
        } catch (error) {
            console.error('Erro ao excluir produto:', error);
            fecharModal();
        }
    };

    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setIdUsuario(response.data.user.id);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };
        buscarDadosUsuario();
    }, []);

    const [modalAbertoComprovante, setModalAbertoComprovante] = useState(false);
    const [dadosComprovante, setDadosComprovante] = useState(null);
    const componentRef = useRef();
    const caixaDeDialogoComprovante = useRef(null); // Ref para o dialog

    const fecharModalComprovante = () => {
        setModalAbertoComprovante(false); // Atualiza estado
        if (caixaDeDialogoComprovante.current) {
            caixaDeDialogoComprovante.current.close();
        }
    };

    const abrirModalComprovante = () => {
        setModalAbertoComprovante(true); // Atualiza estado
        if (caixaDeDialogoComprovante.current) {
            caixaDeDialogoComprovante.current.showModal();
        }
    };

    const gerarComprovante = ({ pedido, cliente, itens }) => {
        console.log('Chamando gerarComprovante com:', { pedido, cliente, itens }); // Log 1: Verifica props
        if (!pedido || !Array.isArray(itens) || itens.length === 0) {
            console.log('Dados insuficientes — saindo!'); // Log 2: Se falhar aqui
            alert('Dados insuficientes!');
            return;
        }
        const clienteFinal = {
            ...cliente,
            cpf_cnpj: cliente?.cpf_cnpj || cpfCnpj || 'N/A',
            ie: cliente?.ie || cliente?.inscricao_estadual || ie || ''
        };
        const dados = {
            pedido,
            cliente: clienteFinal || { nome: 'N/A' /* fallbacks */ },
            itens,
            pagamentos: pedido.pagamentos || {},
            usuarioId: usuario_id,
            nivelAcesso: nivelAcesso
        };
        console.log('Setando dados:', dados); // Log 3: Antes do set
        setDadosComprovante(dados);
        abrirModalComprovante(); // Ou setModalAbertoComprovante(true)
    };

    const clientesFiltrados = clientes.filter((cliente) =>
        cliente.nome.toLowerCase().includes(pesquisa.toLowerCase())
    );

    useEffect(() => {
        const fetchClientes = async () => {
            try {
                const response = await api.get('/listarclientes');
                console.log(response);
                setClientes(response.data.clientes || []);
            } catch (error) {
                console.error('Erro ao carregar clientes:', error);
            }
        };
        if (usuario_id) fetchClientes();
    }, [usuario_id]);

    const produtosFiltrados = produtos.filter((produto) =>
        produto.nome.toLowerCase().includes(pesquisaProduto.toLowerCase())
    );

    const produtosCarrinhoFiltrados = carrinho.filter((item) =>
        item.nome.toLowerCase().includes(pesquisaProdutosCarrinho.toLowerCase())
    );

    useEffect(() => {
        setLoading(true);
        const fetchPedido = async () => {
            try {
                const { data } = await api.get(`/pedidos/${id_pedido}`);
                if (!data.success) {
                    showToast(data.message || 'Erro ao carregar pedido', 'error');
                    return;
                }
                const { pedido, itens, lucro_total } = data;
                setPedido(pedido);
                setItem(itens);
                setLucroTotal(lucro_total || 0);
                console.log("Lucro Total recebido:", lucro_total);
                console.log("Itens com lucro:", itens.map(i => ({ id: i.id, lucro_item: i.lucro_item, preco_compra: i.preco_compra })));
                const checks = {};
                itens.forEach(it => {
                    checks[it.id] = !!it.checkItem;
                });
                setItemChecks(checks);
                console.log("Pedido carregado:", data);

                // 3) buscar dados do cliente
                const respCliente = await api.get(`/clientes/${pedido.cliente.id}`);
                const cliente = respCliente.data.cliente;
                if (!cliente) {
                    console.error("Cliente não encontrado.");
                    return;
                }
                // formatar e setar campos do cliente
                const cpfCnpjFormatado =
                    cliente.cpf_cnpj.length === 11
                        ? formatadorCPF(cliente.cpf_cnpj)
                        : formatadorCNPJ(cliente.cpf_cnpj);

                setNome(cliente.nome);
                setCpfCnpj(cpfCnpjFormatado);
                setEmail(cliente.email);
                setNivel(cliente.nivel_acesso);
                setCelular(formatadorNumeroCelular(cliente.celular));
                setIe(cliente.ie || cliente.inscricao_estadual || '');
                setIdCliente(cliente.id);
                setDataNascimento(
                    cliente.data_nascimento
                        ? new Date(cliente.data_nascimento).toLocaleDateString("pt-BR")
                        : ""
                );
                setSexo(cliente.sexo);

                const respEnd = await api.get(`/buscarendereco/${pedido.endereco_id}`);
                console.log('Endereço carregado:', respEnd.data);

                if (respEnd.data.success) {
                    const endereco = respEnd.data.endereco;
                    setCep(endereco.cep || "");
                    setLogradouro(endereco.logradouro || "");
                    setNumero(endereco.numero || "");
                    setComplemento(endereco.complemento || "");
                    setBairro(endereco.bairro || "");
                    setCidade(endereco.cidade || "");
                    setEstado(endereco.estado || "");
                } else {
                    console.warn(respEnd.data.message);
                }


                const endereco = `${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado}, Brasil`;
                const geocodeUrl = `/geocode?endereco=${encodeURIComponent(endereco)}`;

                const res = await api.get(geocodeUrl);

                if (res.data && res.data.length > 0) {
                    const lat = parseFloat(res.data[0].lat);
                    const lon = parseFloat(res.data[0].lon);
                    setDestination({ lat, lng: lon });
                } else {
                    console.warn("Endereço não encontrado na geocodificação.");
                }
            } catch (err) {
                console.error("Erro ao carregar edição:", err);
                showToast('Não foi possível carregar os dados do pedido', 'error');
            } finally {
                setLoading(false);
            }
        };

        if (id_pedido) {
            fetchPedido();
        }
    }, [id_pedido]);

    const handleEdit = (id) => {
        console.log(`Editar pedido com ID: ${id}`);
        navigate('/menu/pedidos/editarpedido', { state: { id } });
    };

    const clienteEhCnpj = cpfCnpj.replace(/\D/g, '').length > 11;

    const statusList = [
        'Pedido Efetuado',
        'Separado',
        'Incompleto',
        'Enviado',
        'Entregue',
        'Cancelado'
    ];

    const [loadingItems, setLoadingItems] = useState({});

    const [itemChecks, setItemChecks] = useState(() =>
        item.reduce((acc, it) => {
            acc[it.id] = !!it.checkItem; // ou false se não vier
            return acc;
        }, {})
    );

    // dentro do seu componente
    async function handleToggleItem(itm) {
        const id = itm.id;                   // id do itens_pedido
        const pedidoId = itm.id_pedido;      // CORREÇÃO: use itm.id_pedido
        const checked = !!itemChecks[id];
        const novo = !checked;

        if (!usuario_id) {
            console.error('usuario_id não definido!');
            // opcional: mostrar toast e retornar
            return;
        }

        if (loadingItems[id]) return;

        // otimista
        setItemChecks(prev => ({ ...prev, [id]: novo }));
        setLoadingItems(prev => ({ ...prev, [id]: true }));

        try {
            const payload = {
                usuarioId: usuario_id,
                id_item_pedido: id,
                novoStatus: novo,
                registrarHistorico: false
            };
            console.log('Payload enviado:', payload);

            const url = `/pedidos/${pedidoId}/atualizar-status-item`;
            const resp = await api.put(url, payload);

            if (!resp.data || !resp.data.success) {
                setItemChecks(prev => ({ ...prev, [id]: checked }));
                console.error('Backend respondeu sem sucesso:', resp.data);
            } else {
            }
        } catch (err) {
            console.error('Erro ao alterar status do item:', err);
            if (err.response) {
                console.error('Resposta do servidor (err.response.data):', err.response.data);
                console.error('Status:', err.response.status, err.response.statusText);
            } else if (err.request) {
                console.error('Requisição enviada, sem resposta:', err.request);
            } else {
                console.error('Erro ao configurar a requisição:', err.message);
            }

            setItemChecks(prev => ({ ...prev, [id]: checked }));
        } finally {
            setLoadingItems(prev => ({ ...prev, [id]: false }));
        }
    }

    const [status, setStatus] = useState(pedido.status);

    useEffect(() => {
        setStatus(pedido.status);
    }, [pedido.status]);

    const [currentIndex, setCurrentIndex] = useState(
        statusList.findIndex(s => s.statusKey === status)
    );

    const clienteParaComprovante = {
        nome,
        email,
        celular: celular.replace(/\D/g, ''),
        cpf_cnpj: cpfCnpj.replace(/\D/g, ''),
        ie,
        inscricao_estadual: ie,
        nivel_acesso: nivel,
        endereco: {
            logradouro,
            numero,
            complemento,
            bairro,
            cidade,
            estado,
            cep
        }
    };

    const getStepClass = (stepStatus) => {
        const currentIndex = statusList.indexOf(pedido.status);
        const stepIndex = statusList.indexOf(stepStatus);

        if (pedido.status === 'Cancelado' && stepStatus === 'Cancelado') {
            return 'cancelado'; // botão vermelho
        }

        if (stepIndex < currentIndex) return 'completed';
        if (stepIndex === currentIndex) return 'active';
        return ''; // futuro (branco)
    };


    const toggleItemCheck = id =>
        setItemChecks(c => ({ ...c, [id]: !c[id] }));

    const handleChangeStatus = (novoStatus) => {
        const checks = Object.values(itemChecks);
        const temItens = checks.length > 0;
        const todosMarcados = temItens && checks.every(v => v);

        if (novoStatus === 'Separado' || novoStatus === 'Enviado' || novoStatus === 'Entregue') {
            if (!temItens || !todosMarcados) {
                mostrarMensagem('Você só pode marcar como "Separado" quando todos os itens estiverem OK.');
                return;
            }
        }

        if (novoStatus === 'Incompleto') {
            if (todosMarcados) {
                mostrarMensagem('Não é possível marcar como "Incompleto" quando todos os itens estão marcados. Desmarque pelo menos um item.');
                return;
            }
        }

        if (novoStatus === 'Separado') {
            setStatusPendente('Separado');
            dialogSepararRef.current?.showModal();
            return;
        }

        api.put(`/usuario/${usuario_id}/pedidos/${pedido.id}/atualizar-status`, {
            itemChecks: itemChecks,
            statusAtual: novoStatus
        })
            .then(response => {
                setPedido(prev => ({
                    ...prev,
                    status: novoStatus
                }));
            })
            .catch(error => {
                console.error("Erro ao alterar status", error);
                showToast('Erro ao atualizar status', 'error');
            });
    };

    const [valorPagoInput, setValorPagoInput] = useState(0);
    const [valorPagoConfirmado, setValorPagoConfirmado] = useState(0);


    const [metodo, setMetodo] = useState('Pix');

    useEffect(() => {
        if (pedido) {
            const valor = pedido.valor_pago != null ? pedido.valor_pago : pedido.total;
            setValorPagoInput(valor);
            setValorPagoConfirmado(pedido.valor_pago ?? 0);
            setMetodo(pedido.metodo_pagamento ?? 'Pix');
        }
    }, [pedido]);


    // 4) Cálculos de exibição
    const total = pedido.total;
    const valorPago = valorPagoInput;
    const percentPago = total > 0 ? Math.min((valorPago / total) * 100, 100) : 0;
    const restante = total - valorPago;

    // 5) Envio para o backend
    const handleMarkPaid = async () => {
        try {
            const hoje = new Date().toISOString().split('T')[0];
            const payload = {
                valor_pago: valorPagoInput,
                status_pagamento: 'Pago',
                data_pagamento: hoje,
                metodo_pagamento: metodo,
                usuarioId: usuario_id
            };

            const { data } = await api.put(`/pedidos/${pedido.id}/pagamento`, payload);

            if (data.success) {
                setValorPagoConfirmado(valorPagoInput);
                setPedido(p => p && ({
                    ...p,
                    valor_pago: valorPagoInput,
                    status_pagamento: 'Pago',
                    data_pagamento: hoje,
                    metodo_pagamento: metodo
                }));
                showToast('Pagamento registrado com sucesso!', 'success');
            } else {
                showToast('Erro: ' + data.message, 'error');
            }
        } catch (err) {
            console.error(err);
            showToast('Não foi possível atualizar o pagamento', 'error');
        }
    };

    function getFilenameFromContentDisposition(headerValue) {
        if (!headerValue) return null;
        // tenta extrair filename*=UTF-8''nome.pdf ou filename="nome.pdf"
        const filenameStarMatch = headerValue.match(/filename\*=UTF-8''(.+?)(;|$)/i);
        if (filenameStarMatch) return decodeURIComponent(filenameStarMatch[1]);

        const filenameMatch = headerValue.match(/filename="?([^"]+)"?/i);
        if (filenameMatch) return filenameMatch[1];

        return null;
    }

    const handleDownloadClick = () => {
        if (componentRef.current?.downloadPDF) {
            componentRef.current.downloadPDF();
        } else {
            console.error('Função de download não encontrada no ComprovantePedido!');
        }
    };

    const todosItensChecados = item.length > 0 && Object.values(itemChecks).every(Boolean);

    return (
        <section className='container-principal-visualizarPedido'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse produto?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirProduto}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id="DialogMensagem" className={mostrarDialogMensagem ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>{dialogMensagem}</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-ok" onClick={fecharDialogMensagem}>
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog ref={dialogSepararRef}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Confirmar que todos os itens foram separados corretamente?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarMudancaStatus}>Confirmar</button>
                            <button className="bnt-nao" onClick={() => { dialogSepararRef.current?.close(); setStatusPendente(null); }}>Cancelar</button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog
                id="caixaDeDialogoComprovante"
                ref={caixaDeDialogoComprovante}
                open={modalAbertoComprovante}
            >
                <div className="comprovante">
                    {dadosComprovante && (
                        <ComprovantePedido ref={componentRef} {...dadosComprovante} />
                    )}
                </div>

                <div className="botoesModal">
                    <button onClick={handleDownloadClick} className="btnDownload">
                        Baixar PDF
                    </button>
                    <button onClick={fecharModalComprovante} className="btn-fechar">
                        Fechar
                    </button>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main className='main-visualizarPedido'>
                <MenuLateral />
                <section className='conteudo-visualizarPedido'>
                    <div className='titulo-visualizarPedido'>
                        <h1><span>Pedidos</span> &gt; Visualizar Pedido</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'><path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' /><path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'><animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' /></path></svg>
                            <h2>Carregando dados do pedido</h2>
                        </div>
                    ) : (
                        <div className='detalhes-cliente'>
                            <div className="conteudo-DescricaoCliente">
                                <div className="cabecalho-DescricaoClienteTitulo">
                                    <h2>Dados do Cliente</h2>
                                </div>
                                <div className="dados-DescricaoCliente">
                                    <div className="dadoDuplo">
                                        <div className="dado">
                                            <strong>Nome:</strong>
                                            <p>{nome}</p>
                                        </div>
                                        <div className="dado">
                                            <strong>CPF/CNPJ:</strong>
                                            <p>{cpfCnpj}</p>
                                        </div>
                                        {clienteEhCnpj && ie && (
                                            <div className="dado">
                                                <strong>I.E.:</strong>
                                                <p>{ie}</p>
                                            </div>
                                        )}
                                    </div>
                                    <div className="dadoDuplo">
                                        <div className="dado">
                                            <strong>Email:</strong>
                                            <p>{email}</p>
                                        </div>
                                        <div className="dado">
                                            <strong>Celular:</strong>
                                            <p>{celular}</p>
                                        </div>
                                    </div>
                                    <div className="dadoDuplo">
                                        <div className="dado">
                                            <strong>Data de nascimento:</strong>
                                            <p>{dataNascimento}</p>
                                        </div>
                                        <div className="dado">
                                            <strong>Sexo:</strong>
                                            <p>{sexo}</p>
                                        </div>
                                        <div className="dado">
                                            <strong>Perfil:</strong>
                                            <p>{nivel}</p>
                                        </div>
                                    </div>
                                    <div className="bnt-acoes">
                                        <a href={`https://wa.me/55${celular.replace(/\D/g, "")}`} target="_blank" rel="noopener noreferrer" className="botao-whatsapp"> <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M32.7188 6.20635C30.9995 4.4703 28.9519 3.09379 26.6953 2.15703C24.4387 1.22027 22.0183 0.742007 19.575 0.750101C9.3375 0.750101 0.99375 9.09385 0.99375 19.3314C0.99375 22.6126 1.85625 25.8001 3.46875 28.6126L0.84375 38.2501L10.6875 35.6626C13.4063 37.1439 16.4625 37.9313 19.575 37.9313C29.8125 37.9313 38.1563 29.5876 38.1563 19.3501C38.1563 14.3814 36.225 9.7126 32.7188 6.20635ZM19.575 34.7813C16.8 34.7813 14.0812 34.0314 11.7 32.6251L11.1375 32.2876L5.2875 33.8251L6.84375 28.1251L6.46875 27.5439C4.92665 25.0821 4.10798 22.2362 4.10625 19.3314C4.10625 10.8189 11.0437 3.88135 19.5562 3.88135C23.6812 3.88135 27.5625 5.49385 30.4688 8.41885C31.908 9.85109 33.0486 11.5549 33.8243 13.4313C34.6 15.3078 34.9954 17.3196 34.9875 19.3501C35.025 27.8626 28.0875 34.7813 19.575 34.7813ZM28.05 23.2314C27.5812 23.0064 25.2937 21.8814 24.8812 21.7126C24.45 21.5626 24.15 21.4876 23.8313 21.9376C23.5125 22.4064 22.6312 23.4564 22.3687 23.7564C22.1062 24.0751 21.825 24.1126 21.3562 23.8689C20.8875 23.6439 19.3875 23.1376 17.625 21.5626C16.2375 20.3251 15.3187 18.8064 15.0375 18.3376C14.775 17.8689 15 17.6251 15.2437 17.3814C15.45 17.1751 15.7125 16.8376 15.9375 16.5751C16.1625 16.3126 16.2563 16.1064 16.4063 15.8064C16.5563 15.4876 16.4812 15.2251 16.3687 15.0001C16.2562 14.7751 15.3187 12.4876 14.9437 11.5501C14.5687 10.6501 14.175 10.7626 13.8938 10.7439H12.9937C12.675 10.7439 12.1875 10.8564 11.7562 11.3251C11.3437 11.7939 10.1438 12.9189 10.1438 15.2064C10.1438 17.4939 11.8125 19.7064 12.0375 20.0064C12.2625 20.3251 15.3187 25.0126 19.9687 27.0189C21.075 27.5064 21.9375 27.7876 22.6125 27.9939C23.7187 28.3501 24.7313 28.2939 25.5375 28.1814C26.4375 28.0501 28.2937 27.0564 28.6687 25.9689C29.0625 24.8814 29.0625 23.9626 28.9313 23.7564C28.8 23.5501 28.5187 23.4564 28.05 23.2314Z" />
                                        </svg>
                                            Conversar no WhatsApp </a>
                                        <a href={`mailto:${email}`} className="botao-email"><svg width="39" height="31" viewBox="0 0 39 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M38.25 4.25C38.25 2.1875 36.5625 0.5 34.5 0.5H4.5C2.4375 0.5 0.75 2.1875 0.75 4.25V26.75C0.75 28.8125 2.4375 30.5 4.5 30.5H34.5C36.5625 30.5 38.25 28.8125 38.25 26.75V4.25ZM34.5 4.25L19.5 13.625L4.5 4.25H34.5ZM34.5 26.75H4.5V8L19.5 17.375L34.5 8V26.75Z" />
                                        </svg>
                                            Enviar E-mail </a>
                                    </div>
                                </div>
                            </div>

                            <div className="endereco-cliente">
                                <div className="cabecalho-endereco">
                                    <h2>Endereço de Entrega</h2>
                                </div>
                                <div className="container-interno-endereco">
                                    <div className="dados-endereco">
                                        <div className="dadoDuplo">
                                            <div className="dado">
                                                <strong className="titulo">CEP:</strong>
                                                <p> {cep}</p>
                                            </div>
                                            <div className="dado">
                                                <strong className="titulo">Número:</strong>
                                                <p> {numero}</p>
                                            </div>
                                        </div>

                                        <strong>Logradouro:</strong>
                                        <p> {logradouro}</p>

                                        <strong>Bairro:</strong>
                                        <p> {bairro}</p>

                                        <div className="dadoDuplo">
                                            <div className="dado">
                                                <strong className="titulo">Cidade:</strong>
                                                <p> {cidade}</p>
                                            </div>
                                            <div className="dado">
                                                <strong className="titulo">Estado:</strong>
                                                <p> {estado}</p>
                                            </div>
                                        </div>
                                        <strong>Complemento:</strong>
                                        <p>{complemento || '-'}</p>
                                    </div>
                                    <div className="mapa">
                                        <MapComponent
                                            destination={destination} showUserLocation={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="pedido-cliente">
                                <div className="cabecalho-pedido">
                                    <h2>Detalhes do Pedido | ID: #{pedido?.id?.toString().padStart(6, '0') || '000000'}</h2>
                                </div>
                                <div className="container-interno-pedido">
                                    <div className="dados-pedido">
                                        <div className={`jornada-pedido ${pedido.status === 'Cancelado' ? 'cancelada' : ''} ${pedido.status === 'Incompleto' ? 'incompleto' : ''}`}>
                                            <div className="jornada-pedido">
                                                {statusList.map((step, i) => {
                                                    const isDisabled = step === 'Separado' && !todosItensChecados;
                                                    const tooltip = isDisabled ? 'Marque todos os itens para separar' : undefined;
                                                    return (
                                                        <button
                                                            key={i}
                                                            className={`step-${i + 1} ${getStepClass(step)}`}
                                                            onClick={() => handleChangeStatus(step)}
                                                            disabled={isDisabled}
                                                            title={tooltip}
                                                        >
                                                            <p>{step}</p>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                            <div className="status-select-mobile-wrapper">
                                                <select
                                                    className="status-select-mobile"
                                                    value={pedido.status || ''}
                                                    onChange={e => handleChangeStatus(e.target.value)}
                                                >
                                                    {statusList.map(step => (
                                                        <option key={step} value={step}>{step}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="tabela-de-itens">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Produto</th>
                                                        <th>Qtd.</th>
                                                        <th>Preço Unit.</th>
                                                        {item.some(itm => itm.unidades_por_pacote > 1) && <th>Preço/Unid.</th>}
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item.map(itm => (
                                                        <tr className="conteudo" key={itm.id_variacao}>
                                                            <td className="primeiro">
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!itemChecks[itm.id]}
                                                                    onChange={() => handleToggleItem(itm)}
                                                                    disabled={!!loadingItems[itm.id]}
                                                                />
                                                            </td>
                                                            <td>{itm.descricao_produto}</td>
                                                            <td>{itm.quantidade}</td>
                                                            <td>R$ {parseFloat(itm.preco).toFixed(2)}</td>
                                                            {item.some(i => i.unidades_por_pacote > 1) && (
                                                                <td>{itm.unidades_por_pacote > 1 ? formatarPrecoUnitario(itm.preco, itm.unidades_por_pacote) : '-'}</td>
                                                            )}
                                                            <td className="final">
                                                                R$ {(itm.quantidade * parseFloat(itm.preco)).toFixed(2)}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="resumo-pedido">
                                            <div className="card-info">
                                                <strong className="titulo">Qtd. Itens:</strong>
                                                <p>{item.length}</p>
                                            </div>
                                            <div className="card-info">
                                                <strong className="titulo">Sub-Total:</strong>
                                                <p>
                                                    {(Number(pedido.total) || 0).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </p>
                                            </div>
                                            <div className="card-info">
                                                <strong className="titulo">Itens Faltando:</strong>
                                                <p>{item.length - Object.values(itemChecks).filter(Boolean).length}</p>
                                            </div>
                                        </div>


                                        <div className="dadoDuplo">
                                            <div className="dado-criacao">
                                                <strong className="titulo">Data do Pedido:</strong>
                                                <p className="data">
                                                    {pedido.criado_em
                                                        ? new Date(pedido.criado_em).toLocaleString('pt-BR')
                                                        : '—'}
                                                </p>
                                            </div>
                                            <div className='dado'>
                                                <strong>Observação:</strong>
                                                <p> {pedido.observacao || '-'}</p>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            {nivelAcesso === 'Administrador' && (
                                <div className="lucro-pedido">
                                    <div className="cabecalho-lucro">
                                        <h2>Análise de Lucro</h2>
                                    </div>
                                    <div className="container-interno-lucro">
                                        <div className="tabela-lucro">
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Produto</th>
                                                        <th>Qtd.</th>
                                                        <th>Custo Unit.</th>
                                                        <th>Venda Unit.</th>
                                                        <th>Lucro Unit.</th>
                                                        <th>Lucro Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item.map(itm => {
                                                        const unidades = Number(itm.unidades_por_pacote) || 1;
                                                        const precoCompraUnitario = itm.preco_compra != null ? parseFloat(itm.preco_compra) / unidades : null;
                                                        const precoVendaUnitario = parseFloat(itm.preco) / unidades;
                                                        const lucroUnitario = precoCompraUnitario != null ? precoVendaUnitario - precoCompraUnitario : null;
                                                        
                                                        return (
                                                            <tr className="conteudo" key={`lucro-${itm.id_variacao}`}>
                                                                <td className="primeiro">{itm.descricao_produto}</td>
                                                                <td>{itm.quantidade}</td>
                                                                <td>
                                                                    {itm.preco_compra != null
                                                                        ? `R$ ${precoCompraUnitario.toFixed(2)}`
                                                                        : 'N/A'}
                                                                </td>
                                                                <td>R$ {precoVendaUnitario.toFixed(2)}</td>
                                                                <td>
                                                                    {lucroUnitario != null
                                                                        ? `R$ ${lucroUnitario.toFixed(2)}`
                                                                        : 'N/A'}
                                                                </td>
                                                                <td className="final">
                                                                    {itm.lucro_item != null
                                                                        ? `R$ ${parseFloat(itm.lucro_item).toFixed(2)}`
                                                                        : 'N/A'}
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="resumo-lucro">
                                            <div className="card-lucro">
                                                <strong className="titulo">Lucro Total do Pedido:</strong>
                                                <p className="valor-lucro">
                                                    {(Number(lucroTotal) || 0).toLocaleString('pt-BR', {
                                                        style: 'currency',
                                                        currency: 'BRL',
                                                    })}
                                                </p>
                                            </div>
                                            <div className="card-lucro">
                                                <strong className="titulo">Margem de Lucro:</strong>
                                                <p className="valor-lucro">
                                                    {(Number(pedido.total) > 0 && Number(lucroTotal) > 0)
                                                        ? `${((Number(lucroTotal) / Number(pedido.total)) * 100).toFixed(1)}%`
                                                        : '0%'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="pagamento-cliente">
                                <div className="cabecalho-pagamento">
                                    <h2>Pagamento</h2>
                                </div>

                                <div className="container-interno-pagamento">
                                    {nivelAcesso === 'Administrador' ? (
                                        <>
                                            <div className="resumo-pagamento">
                                                <div className="linha">
                                                    <span>Total do Pedido:</span>
                                                    <strong>
                                                        {(Number(total) || 0).toLocaleString('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL',
                                                        })}
                                                    </strong>
                                                </div>

                                                <div className={`barra-progresso ${pedido.status === 'Cancelado' ? 'cancelada' : ''}`}>
                                                    <div
                                                        className={`fill ${pedido.status === 'Cancelado' ? 'cancelado' : percentPago >= 100 ? 'completo' : ''}`}
                                                        style={{ width: pedido.status === 'Cancelado' ? '100%' : `${percentPago}%` }}
                                                        title={pedido.status === 'Cancelado' ? 'Pedido cancelado' : `Pago: ${(Number(valorPago) || 0).toLocaleString('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL',
                                                        })}`}
                                                    />
                                                </div>

                                                <div className="linha">
                                                    <span>Pago até agora:</span>
                                                    <strong>{valorPago.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</strong>
                                                </div>

                                                <div className="linha">
                                                    <span>Restante:</span>
                                                    <strong className={valorPago >= total ? 'paid' : ''}>
                                                        {restante.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                                    </strong>
                                                </div>

                                                {restante >= 0 && (
                                                    <div className="editar-pagamento">
                                                        <div className='input-valor'>
                                                            <CurrencyInput
                                                                prefix="R$ "
                                                                decimalSeparator=","
                                                                groupSeparator="."
                                                                decimalsLimit={2}
                                                                allowNegativeValue={false}
                                                                placeholder="R$ 0,00"
                                                                value={valorPagoInput?.toString().replace('.', ',') || ''}
                                                                onValueChange={(value) => {
                                                                    const valorNumerico = parseCurrency(value); // Função que converte "R$ 1.234,56" -> 1234.56
                                                                    const maxPermitido = total;

                                                                    if (!isNaN(valorNumerico) && valorNumerico <= maxPermitido) {
                                                                        setValorPagoInput(valorNumerico);
                                                                    } else {
                                                                        setValorPagoInput(maxPermitido);
                                                                    }
                                                                }}
                                                                disabled={valorPagoConfirmado >= total}
                                                            />
                                                        </div>
                                                        <div className='select-metodo'>
                                                            <select
                                                                value={metodo}
                                                                onChange={e => setMetodo(e.target.value)}
                                                                disabled={valorPagoConfirmado >= total}
                                                            >
                                                                <option value="Pix">Pix</option>
                                                                <option value="Dinheiro">Dinheiro</option>
                                                                <option value="Cartão de Crédito">Cartão de Crédito</option>
                                                                <option value="Boleto">Boleto</option>
                                                                <option value="Transferência Bancária">Transferência Bancária</option>
                                                                <option value="Cheque">Cheque</option>
                                                            </select>
                                                        </div>
                                                        <button
                                                            onClick={handleMarkPaid}
                                                            style={{
                                                                backgroundColor: valorPagoInput >= total ? '#32CD32' : '#131C46',
                                                                color: '#fff',
                                                                padding: '10px 15px',
                                                                borderRadius: '25px',
                                                                border: 'none',
                                                                fontSize: '16px',
                                                                cursor: valorPagoInput >= total ? 'default' : 'pointer',
                                                                transition: 'background-color 0.3s',
                                                                width: '100%',
                                                            }}
                                                            disabled={valorPagoConfirmado >= total}
                                                        >
                                                            {valorPagoConfirmado >= total ? 'Pago' : 'Marcar como Pago'}
                                                        </button>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="dados-pagamento">
                                                <div className="dadoDuplo">
                                                    <div className="dado">
                                                        <strong className="titulo">Método:</strong>
                                                        <p>{pedido.metodo_pagamento ? pedido.metodo_pagamento : '—'}</p>
                                                    </div>
                                                    <div className="dado">
                                                        <strong className="titulo">Status do Pagamento:</strong>
                                                        <p>{pedido.status_pagamento ? pedido.status_pagamento : '—'}</p>
                                                    </div>
                                                </div>

                                                <div className="dadoDuplo">
                                                    <div className="dado">
                                                        <strong className="titulo">Data do Pagamento:</strong>
                                                        <p>{pedido.data_pagamento ? new Date(pedido.data_pagamento).toLocaleDateString('pt-BR') : '—'}</p>
                                                    </div>
                                                    <div className="dado">
                                                        <strong className="titulo">Valor Pago:</strong>
                                                        <p>
                                                            {valorPagoConfirmado.toLocaleString('pt-BR', {
                                                                style: 'currency',
                                                                currency: 'BRL'
                                                            })}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div style={{ padding: '20px', textAlign: 'center', color: '#999' }}>
                                            <p>Informações de pagamento restritas a administradores.</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='bnts-produtos'>
                                <button className='bnt-editar' onClick={() => handleEdit(pedido.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg>Editar Produto</button>
                                <button className='bnt-excluir' onClick={() => abrirModalExcluir(pedido.id)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg>Excluir Produto</button>
                                <button onClick={() => gerarComprovante({ pedido, cliente: clienteParaComprovante, itens: item })} className='bnt-comprovante'><svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.333252 2.33335C0.333252 1.89133 0.508847 1.4674 0.821407 1.15484C1.13397 0.842282 1.55789 0.666687 1.99992 0.666687H8.66658C8.88758 0.666734 9.09951 0.754563 9.25575 0.910854L13.4224 5.07752C13.5787 5.23376 13.6665 5.44569 13.6666 5.66669V15.6667C13.6666 16.1087 13.491 16.5326 13.1784 16.8452C12.8659 17.1578 12.4419 17.3334 11.9999 17.3334H1.99992C1.55789 17.3334 1.13397 17.1578 0.821407 16.8452C0.508847 16.5326 0.333252 16.1087 0.333252 15.6667V2.33335ZM11.6549 5.66669L8.66658 2.67835V5.66669H11.6549ZM6.99992 2.33335H1.99992V15.6667H11.9999V7.33335H7.83325C7.61224 7.33335 7.40028 7.24556 7.244 7.08928C7.08772 6.933 6.99992 6.72103 6.99992 6.50002V2.33335ZM3.66659 9.83335C3.66659 9.61234 3.75438 9.40038 3.91066 9.2441C4.06694 9.08782 4.2789 9.00002 4.49992 9.00002H9.49992C9.72093 9.00002 9.93289 9.08782 10.0892 9.2441C10.2455 9.40038 10.3333 9.61234 10.3333 9.83335C10.3333 10.0544 10.2455 10.2663 10.0892 10.4226C9.93289 10.5789 9.72093 10.6667 9.49992 10.6667H4.49992C4.2789 10.6667 4.06694 10.5789 3.91066 10.4226C3.75438 10.2663 3.66659 10.0544 3.66659 9.83335ZM3.66659 13.1667C3.66659 12.9457 3.75438 12.7337 3.91066 12.5774C4.06694 12.4212 4.2789 12.3334 4.49992 12.3334H9.49992C9.72093 12.3334 9.93289 12.4212 10.0892 12.5774C10.2455 12.7337 10.3333 12.9457 10.3333 13.1667C10.3333 13.3877 10.2455 13.5997 10.0892 13.7559C9.93289 13.9122 9.72093 14 9.49992 14H4.49992C4.2789 14 4.06694 13.9122 3.91066 13.7559C3.75438 13.5997 3.66659 13.3877 3.66659 13.1667Z" /></svg>Baixar Comprovante</button>
                            </div>

                        </div>
                    )}
                </section>
            </main >
            <Rodape />
        </section >
    );
}